import { SdkContext } from '../internal'
import type { SendingReputationCommunity, SendingReputationSettings, SendingReputationSettingsInput } from '@/types/sendingReputation'

/** F-143, SuperAdmin only (no `X-CommunityId`): communities in alert or suspended, the audited lift and per-community limits. */
export class AdminSendingReputationResource {
  constructor(private ctx: SdkContext) {}

  async list(): Promise<SendingReputationCommunity[]> {
    const res = await this.ctx.call<unknown>({ httpMethod: 'GET', path: '/admin/sending-reputation' })
    return Array.isArray(res) ? (res as SendingReputationCommunity[]) : ((res as { items?: SendingReputationCommunity[] } | null)?.items ?? [])
  }

  async get(communityId: string): Promise<SendingReputationCommunity> {
    return this.ctx.call({ httpMethod: 'GET', path: '/admin/communities/{communityId}/sending-reputation' }, { communityId })
  }

  /** Ends the suspension now; the reason (10 to 2,000 characters) goes to the community's audit and the owners are told. */
  async lift(communityId: string, reason: string): Promise<SendingReputationCommunity> {
    return this.ctx.call({ httpMethod: 'POST', path: '/admin/communities/{communityId}/sending-reputation/lift', hasBody: true }, { communityId, body: { reason } })
  }

  /** `null` brings a field back to the default; `reset: true` clears them all. */
  async updateSettings(communityId: string, body: SendingReputationSettingsInput): Promise<{ settings: SendingReputationSettings; custom: Partial<SendingReputationSettings> | null; defaults: SendingReputationSettings }> {
    return this.ctx.call({ httpMethod: 'PUT', path: '/admin/communities/{communityId}/sending-reputation/settings', hasBody: true }, { communityId, body })
  }
}
